import { Service } from "@warda/library-ui/contexts/AppWebSocketContext";
import { RENDITION } from "../interfaces";
import { BASE_URL } from "../constants/keys";
import addQueryParamsToUrl from "../utils/addQueryParamsToUrl";
// NOTE taccone se è true abilita la vecchia api prima dello sviluppo di Gabri
// W3IM-1029
// SEECOMM-7511
const taccone = true;
var SEECOMMERCE_UPLOAD_TYPE;
(function (SEECOMMERCE_UPLOAD_TYPE) {
    SEECOMMERCE_UPLOAD_TYPE["POST"] = "post";
    SEECOMMERCE_UPLOAD_TYPE["SHOOTING"] = "shooting";
    SEECOMMERCE_UPLOAD_TYPE["XLSX"] = "xlsx";
    SEECOMMERCE_UPLOAD_TYPE["XLSXPRO"] = "xlsxpro";
    SEECOMMERCE_UPLOAD_TYPE["VIDEO"] = "video";
    SEECOMMERCE_UPLOAD_TYPE["DOCUMENT"] = "document";
})(SEECOMMERCE_UPLOAD_TYPE || (SEECOMMERCE_UPLOAD_TYPE = {}));
const apiUrls = {
    getAggregateTypes: {
        url: () => `${BASE_URL}/${Service.SC}/config/aggregateTypes`,
        method: "GET",
    },
    newUpload: {
        url: (type) => `${BASE_URL}/${Service.SC}/products/upload${type ? `/${type}` : ""}/new`,
        method: "POST",
    },
    newUploadConfirm: {
        url: (fileId, service, type) => `${BASE_URL}/${service === Service.SC ? service + "/products" : service}/upload/confirm${type ? `/${type}` : ""}/${fileId}`,
        method: "PUT",
    },
    restoreMedia: {
        url: (fileId) => `${BASE_URL}/${Service.SC}/products/${fileId}/restore`,
        method: "POST",
    },
    deleteMedia: {
        url: (fileId, type, physical) => `${BASE_URL}/${Service.SC}/products/media-content/${type}/${fileId}${physical === true ? "?physicalDelete=true" : ""}`,
        method: "DELETE",
    },
    deleteMediaMassive: {
        url: () => `${BASE_URL}/${Service.SC}/products/massive-delete`,
        method: "POST",
    },
    emptyProductMediaTrash: {
        url: () => `${BASE_URL}/${Service.SC}/products/trash`,
        method: "DELETE",
    },
    postMultiReady: {
        url: (type) => `${BASE_URL}/${Service.SC}/products/${type}/multiReady`,
        method: "",
    },
    postReady: {
        url: (type) => `${BASE_URL}/${Service.SC}/products/${type}/ready`,
        method: "POST",
    },
    deleteReady: {
        url: (type) => `${BASE_URL}/${Service.SC}/products/${type}/ready`,
        method: "DELETE",
    },
    postViewCheck: {
        url: () => `${BASE_URL}/${Service.SC}/products/viewCheck`,
        method: "POST",
    },
    postViews: {
        url: () => `${BASE_URL}/${Service.SC}/products/views`,
        method: "POST",
    },
    postProduction: {
        url: () => `${BASE_URL}/${Service.SC}/products/postProduction`,
        method: "POST",
    },
    postExportData: {
        url: () => `${BASE_URL}/${Service.SC}/export`,
        method: "POST",
    },
    downloadMediaMassive: {
        url: () => `${BASE_URL}/${Service.SC}/products/download-massive`,
        method: "POST",
    },
    downloadMedia: {
        url: (fileId, params) => {
            let base = `${BASE_URL}/${Service.SC}/media/download-single/${fileId}`;
            const obj = {
                ...params,
                deleted: params.deleted || undefined,
                rendition: params.rendition === RENDITION.original
                    ? undefined
                    : params.rendition,
            };
            if (taccone) {
                base = `${BASE_URL}/mcr/media-content/${fileId}`;
                if (!!obj.rendition) {
                    base = base + "/" + obj.rendition;
                    delete obj.rendition;
                }
            }
            return addQueryParamsToUrl(base, obj);
        },
        method: "GET",
    },
    zoomMedia: {
        url: (fileId, deleted) => {
            let base = `${BASE_URL}/${Service.SC}/media/zoom-tiles/${fileId}/tiles.dzi`;
            if (taccone) {
                base = `${BASE_URL}/mcr/media-content/${fileId}/zoom-tiles/tiles.dzi`;
            }
            return addQueryParamsToUrl(base, {
                redirect: false,
                deleted: deleted || undefined,
            });
        },
        method: "GET",
    },
    editProduct: {
        url: () => `${BASE_URL}/${Service.SC}/products`,
        method: "PUT",
    },
    editMultiProduct: {
        url: () => `${BASE_URL}/${Service.SC}/products/multiProduct`,
        method: "PUT",
    },
    assignment: {
        url: () => `${BASE_URL}/${Service.SC}/products/assignment`,
        method: "POST",
    },
    multiAssignment: {
        url: () => `${BASE_URL}/${Service.SC}/products/multiAssignment`,
        method: "POST",
    },
    distributions: {
        url: () => `${BASE_URL}/${Service.SC}/products/distributions`,
        method: "POST",
    },
    mediaMultiViewData: {
        url: `${BASE_URL}/${Service.SC}/products/multiViewData`,
        method: "POST",
    },
    documentMultiViewData: {
        url: `${BASE_URL}/${Service.SC}/products/document/multiViewData`,
        method: "POST",
    },
    multiResetViews: {
        url: () => `${BASE_URL}/${Service.SC}/products/multiResetViews`,
        method: "POST",
    },
    resetAttribute: {
        url: () => `${BASE_URL}/${Service.SC}/products/resetAttribute`,
        method: "POST",
    },
    canPublicFile: {
        url: (service, fileId) => `${BASE_URL}/${service}/publish/publishable/${fileId}`,
        method: "GET",
    },
    exportProductEvents: {
        url: () => `${BASE_URL}/${Service.SC}/products/events`,
        method: "POST",
    },
    exportXlsx: {
        url: () => `${BASE_URL}/${Service.SC}/export/v2`,
        method: "POST",
    },
    postEasyCatalog: {
        url: () => `${BASE_URL}/${Service.SC}/export/easyCatalog`,
        method: "POST",
    },
    getProduct: {
        url: (id) => {
            const base = `${BASE_URL}/${Service.SC}/products`;
            return addQueryParamsToUrl(base, {
                product: id,
            });
        },
        method: "GET",
    },
    getAttributeDicts: {
        url: () => `${BASE_URL}/${Service.SC}/config/dictionary`,
        method: "POST",
    },
    getBoxviewDocId: {
        url: (fileId, deleted) => {
            const base = `${BASE_URL}/${Service.SC}/media/download-document/${fileId}/documentId`;
            return addQueryParamsToUrl(base, {
                deleted: deleted || undefined,
            });
        },
        method: "GET",
    },
    getBoxviewDocToken: {
        url: (docId, deleted) => {
            const base = `${BASE_URL}/${Service.SC}/media/download-document/${docId}/access-token`;
            return addQueryParamsToUrl(base, {
                deleted: deleted || undefined,
            });
        },
        method: "GET",
    },
    completenessCount: {
        url: () => `${BASE_URL}/${Service.SC}/completeness-count`,
        method: "POST",
    },
    deleteEntities: {
        url: (ids) => {
            if (ids.length === 1)
                return `${BASE_URL}/${Service.SC}/products/entity`;
            else
                return `${BASE_URL}/${Service.SC}/products/entities`;
        },
        method: "DELETE",
    },
};
export default apiUrls;
